// import { Subject } from 'rxjs';

// const subject = new Subject();

// export const lmsDataService = {
//     setData: d => subject.next({ value: d }),
//     clearData: () => subject.next(),
//     getData: () => subject.asObservable()
// };

const data = {
    API_URL: 'https://services.baabtra.com/CourseFileUpload/',
    S3_BASE_URL: 'https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded'
};

export const lmsDataService = {
    setData: (d, k) => {
        data[k] = d;
        var vc2Obj = getVc2ObjFromLC();
        vc2Obj[k] = d;
        localStorage.setItem('vc2Obj', JSON.stringify(vc2Obj))
    },
    clearData: (k) => {
        delete data[k];
        var vc2Obj = getVc2ObjFromLC();
        delete vc2Obj[k];
        localStorage.setItem('vc2Obj', JSON.stringify(vc2Obj))
    },
    getData: (k) => {
        if (data[k]){
            return data[k];
        }
        else {
            var vc2Obj = getVc2ObjFromLC();
            return vc2Obj[k];
        }
    }
};

function getVc2ObjFromLC(){
    var vc2Obj = localStorage.getItem('vc2Obj');

    if(!vc2Obj){
        vc2Obj = {};
        return vc2Obj;
    }

    return JSON.parse(vc2Obj);
}